import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import Carousel from '../Carousel';
import Poster from '../Carousel/components/Poster';
import useRenderChapas from '../../../../hooks/useRenderChapas';
import { selectVcardRecommendations } from '../../selectors/vcard.selector';
import { fetchVcardRecommendations } from 'containers/Vcard/actions/recommendations/vcard.recommendations.actions';
import { clearSeenlast } from 'containers/Vcard/actions/content/content.actions';
import { useNavigate } from 'react-router-dom';
import { getRegion } from 'utils/Region';
import getContentAvailability from 'utils/getContentAvailability';
import Metrics from 'services/metrics';

const EVENT_NAME = 'select_content';
const CURRENT_SECTION = 'vcard';

const Recommended = ({ groupId }) => {
  const recommended = useSelector(selectVcardRecommendations);
  const translations = useSelector(state => state.translations);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { renderLabel } = useRenderChapas();

  const handlePosterClick = clickedPoster => {
    dispatch(clearSeenlast());

    const posterUri = clickedPoster?.title_uri;
    const posterId = clickedPoster?.group_id || clickedPoster?.id || '';
    const carouselTitle = translations.vcard_ribbon_recommendations_label;

    const contentAvailability = getContentAvailability(
      clickedPoster?.format_types?.split(','),
      clickedPoster?.proveedor_code,
    )?.toString();

    const eventInfo = {
      event: EVENT_NAME,
      content_section: CURRENT_SECTION,
      content_list: carouselTitle?.toLowerCase(),
      content_id: clickedPoster?.id,
      content_name: clickedPoster?.title,
      content_type: '', // No es posible obtener este parametro.
      content_category: '', // No es posible obtener este parametro.
      content_availability: contentAvailability,
      content_position: clickedPoster?.contentPosition,
    };

    Metrics.newEvent(eventInfo);

    navigate({
      pathname: `/${getRegion()}/vcard/homeuser/${posterUri}/${posterId}`,
      state: { eventInfo },
    });
  }

  useEffect(
    () => {
      dispatch(
        fetchVcardRecommendations({
          group_id: groupId,
        }),
      );
    },
    [groupId],
  );

  return (
    <Carousel
      title={translations.vcard_ribbon_recommendations_label}
      data={recommended?.data?.map((item, i) => ({
        id: item.id,
        Component:
          <Poster
            item={item}
            renderLabel={renderLabel}
            handleClick={() => handlePosterClick({...item, contentPosition: i})}
          />,
      }))}
    />
  );
};

Recommended.propTypes = {
  groupId: PropTypes.string,
};
export default Recommended;
